import { StyledFooter } from "./styles";

import SocialMediaIcons from "../SocialMediaIcons";
import Logo from "../Logo";

import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

import { useState, useEffect } from "react";

import { useDisclosure } from "@chakra-ui/react";

import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
} from "@chakra-ui/react";

import { Link } from "react-scroll";

function Footer() {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [placement, setPlacement] = useState("right");

  const [windowSize, setWindowSize] = useState(getWindowSize());

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <StyledFooter>
      <Link to="home" spy={true} smooth={true} offset={50} duration={500}><Logo/></Link>
      {windowSize.innerWidth > 970 
      ? 
      (<div className="personalInfo"><p>
        {"("}27{")"} 99229-4565
      </p>
      <p>brunopassos_bp@hotmail.com</p>
      <SocialMediaIcons /></div>) 
      : 
      (<><AiOutlineMenu className="footerIconMenu" onClick={onOpen}/></>)}
      
      <Drawer placement={placement} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />

        <DrawerContent>
          <div className="closeMenuDiv">
            <AiOutlineClose className="menuIcon" onClick={onClose} />
          </div>
          <DrawerBody>
            <p className="menuListItem">{"("}27{")"} 99229-4565</p>
            <p className="menuListItem">brunopassos_bp@hotmail.com</p>
            <p className="menuListItem"><SocialMediaIcons /></p>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </StyledFooter>
  );
}

export default Footer;
